import { Routes } from '@angular/router';
import { AlertsComponent } from './alerts/alerts.component';
import { AreaItemsComponent } from './area-items/area-items.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { BankAccountComponent } from './bank-account/bank-account.component';
import { ButtonsComponent } from './buttons/buttons.component';
import { CalendarsComponent } from './calendars/calendars.component';
import { CatalogueAnalysisComponent } from './catalogue-analysis/catalogue-analysis.component';
import { ColorsComponent } from './colors/colors.component';
import { DialogsComponent } from './dialogs/dialogs.component';
import { IconsComponent } from './icons/icons.component';
import { InputsComponent } from './inputs/inputs.component';
import { LabelsComponent } from './labels/labels.component';
import { LoadersComponent } from './loaders/loaders.component';
import { PopoversComponent } from './popovers/popovers.component';
import { SelectsComponent } from './selects/selects.component';
import { SideFloatingMenuPageComponent } from './side-floating-menu/side-floating-menu.component';
import { TablesComponent } from './tables/tables.component';
import { TabsComponent } from './tabs/tabs.component';
import { TooltipsComponent } from './tooltips/tooltips.component';
import { WriterPublisherRowsComponent } from './writer-publisher-rows/writer-publisher-rows.component';

export const routes: Routes = [
  { path: '', redirectTo: 'buttons', pathMatch: 'full' },
  { path: 'buttons', component: ButtonsComponent },
  { path: 'icons', component: IconsComponent },
  { path: 'labels', component: LabelsComponent },
  { path: 'colors', component: ColorsComponent },
  { path: 'inputs', component: InputsComponent },
  { path: 'selects', component: SelectsComponent },
  { path: 'popovers', component: PopoversComponent },
  { path: 'tables', component: TablesComponent },
  { path: 'alerts', component: AlertsComponent },
  { path: 'tabs', component: TabsComponent },
  { path: 'tooltips', component: TooltipsComponent },
  { path: 'bank-accounts', component: BankAccountComponent },
  { path: 'audio-player', component: AudioPlayerComponent },
  { path: 'calendars', component: CalendarsComponent },
  { path: 'catalogue-analysis', component: CatalogueAnalysisComponent },
  { path: 'loaders', component: LoadersComponent },
  { path: 'side-floating-menu', component: SideFloatingMenuPageComponent },
  { path: 'dialogs', component: DialogsComponent },
  { path: 'area-items', component: AreaItemsComponent },
  { path: 'writer-publisher-rows', component: WriterPublisherRowsComponent },
];
